import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import {ACTIVITY_TYPE} from "../../../../common/Constants";

class MasterOtherItemModifying extends Component {
    qrOptions = [
        {
            label: "YES",
            value: true,
        },
        {
            label: "NO",
            value: false,
        },
    ];

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Varian"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleInput
                                id="input_text_kode_barang_lain"
                                name="kodeotheritem"
                                label="Kode Barang Lain"
                                readOnly={this.props.activityType === ACTIVITY_TYPE.UPDATE}
                                mandatory
                                errorMessage={this.props.errors.kodeotheritem}
                                value={this.props.controls.kodeotheritem.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_barang_lain"
                                name="nameotheritem"
                                label="Nama Barang Lain"
                                mandatory
                                errorMessage={this.props.errors.nameotheritem}
                                value={this.props.controls.nameotheritem.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_kategori"
                                box="search"
                                name="categoryotheritem"
                                label="Kategori"
                                mandatory
                                isClearable
                                errorMessage={this.props.errors.categoryotheritem}
                                options={this.props.dataKategoriDDL}
                                value={this.props.controls.categoryotheritem.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_qrcode"
                                box="search"
                                name="qrotheritem"
                                label="QR Code"
                                mandatory
                                isClearable
                                errorMessage={this.props.errors.qrotheritem}
                                options={this.qrOptions}
                                value={this.props.controls.qrotheritem.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_satuan"
                                box="search"
                                name="satuanotheritem"
                                label="Satuan"
                                mandatory
                                isClearable
                                errorMessage={this.props.errors.satuanotheritem}
                                options={this.props.dataSatuanDDL}
                                value={this.props.controls.satuanotheritem.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default withFormGroup(MasterOtherItemModifying);